<template>
    <div>
        <v-container>
            <v-layout>
                <v-row>
                    <v-col cols="3">
                        <v-text-field label="First Name" v-model="nameDto.firstName" :required="this.isRequired" :rules="requiredRule"></v-text-field>
                    </v-col>
                    <v-col cols="3">
                        <v-text-field label="Middle Name" v-model="nameDto.middleName" :required="this.isRequired" :rules="requiredRule"></v-text-field>
                    </v-col>
                    <v-col cols="3">
                        <v-text-field label="Last Name" v-model="nameDto.lastName" :required="this.isRequired" :rules="requiredRule"></v-text-field>
                    </v-col>
                    <v-col cols="1">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-on="on" v-bind="attrs">mdi-information-outline</v-icon>
                            </template>
                            <span style="color:white;">Please enter the last name as you want it to be on the Birth Certificate. Dashes and spaces are allowed.</span>
                        </v-tooltip>
                    </v-col>
                    <v-col cols="2">
                        <v-select v-model="nameDto.suffix" ref="suffixRef"
                                  :items="suffixes"
                                  item-text="description"
                                  item-value="id"
                                  label="Suffix"
                                  clearable>
                        </v-select>
                    </v-col>
                </v-row>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import lookupService from '@/services/lookupService'
export default {
    props: ['isRequired', 'value'],
    mounted: function () {
        lookupService.GetSuffixes(this.$http).then(response => {
            this.suffixes = response.data
        })
    },
    data: function () {
        return {
            errors: [],
            nameDto: {
                firstName: '',
                middleName: '',
                lastName: '',
                suffix: ''
            },
            suffixes: []
        }
    },
    computed: {
        requiredRule () {
            return this.isRequired ? [v => !!v || 'Required'] : []
        }
    },
    methods: {
        checkFields: function () {
            this.errors = []
            if (this.isRequired && (!this.nameDto.firstName || !this.nameDto.middleName || !this.nameDto.lastName)) {
                this.errors.push('full name is required')
            }
            return this.errors.length > 0
        },
        setNameDto: function (dto) {
            this.nameDto = dto
            this.nameDto.suffix = Number(dto.suffix)
        }
    }
}
</script>
